import { render } from "./BloqueoComponent.vue?vue&type=template&id=5bcad464"
import script from "./BloqueoComponent.vue?vue&type=script&lang=js"
export * from "./BloqueoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__